import React, { useState } from "react";
import Navbar from "../../../components/Navbar/Navbar";
// import Footer from "../../../components/Footer/Footer";

import "./UnsecuredDebtAmount.scss";
import Progress from "../../../components/Progress/Progress";
import ScrollToTop from "../../../components/ScrollToTop/ScrollToTop";
import { StepPreFooter } from "../../../components/Footer/StepPreFooter";

import checkedIcon from "../../../assets/images/checked.png";
import step3Icon from "../../../assets/images/step-icon/step19-icon.png";

import { useForm } from "react-hook-form";
import { updateContact } from "../../../redux/apiCalls";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Box } from "@mui/material";
import { StepBtn } from "../../../components/Button/StepBtn/StepBtn";
import { nextStepDelayTime } from "../../../utils/const";
import { getPrevStepLink } from "utils/functions";
import { getLanderPrefill } from "../../../utils/landerPrefill";

const UnsecuredDebtAmount = () => {
  const unsecuredDebtAmountOptions = [
    "None",
    "$1,000-$4,999",
    "$5,000-$9,999",
    "$10,000-$20,000",
    "Over $20,000"
  ];
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(false);
  const windowWidth = window.innerWidth;
  const isMobile = windowWidth < 768;

  const contactRedux = useSelector((state) => state?.contact?.contact);
  const [unsecuredDebtAmount, setUnsecuredDebtAmount] = useState(
    contactRedux?.debt_amount ?? contactRedux?.unsecuredDebtAmount ?? getLanderPrefill()?.debtAmount ?? ""
  );

  const currentLoc = useLocation();
  const prevLink = getPrevStepLink(currentLoc.pathname);

  const {
    handleSubmit,
    setError,
    clearErrors,
    formState: { errors }
  } = useForm();

  const onSubmit = async (data) => {
    if (!unsecuredDebtAmount) {
      setError("unsecuredDebtAmount", {
        type: "invalid",
        message: "Please select one option."
      });
      return;
    }
    setLoadingButton(true);

    const lead_id = sessionStorage.getItem("lead_id");
    const res = await updateContact(dispatch, contactRedux?._id, {
      lead_id,
      debt_amount: unsecuredDebtAmount
    });

    // SEND DATA TO PHONEXA
    setLoadingButton(false);

    if (res?.status === 200) {
      setTimeout(() => {
        setLoadingButton(false);
        navigate("/payfreequency");
      }, nextStepDelayTime);
    }
  };

  return (
    <Box className="step-19">
      <Navbar />
      <ScrollToTop />
      <Box
        sx={{
          width: "100%",
          maxWidth: "700px",
          margin: "20px auto"
        }}
      >
        <Box
          sx={{
            width: "100%",

            margin: "10px auto 30px",
            padding: isMobile && "0 15px"
          }}
        >
          <Progress step={10} />
        </Box>
        <div className="step-main">
          <form className="step-form" onSubmit={handleSubmit(onSubmit)}>
            <Box sx={{ textAlign: "center", marginBottom: "11px" }}>
              <img
                style={{
                  maxWidth: isMobile && "42px"
                }}
                src={step3Icon}
                alt=""
              />
            </Box>
            <h2 className="title">
              How much unsecured debt do you have to pay?
            </h2>

            <div className="form-control">
              <div className="list-btn-radio">
                {unsecuredDebtAmountOptions.map((option, index) => (
                  <button
                    key={index}
                    className={`btn-radio ${
                      unsecuredDebtAmount === option ? "active" : ""
                    }`}
                    onClick={(e) => {
                      setUnsecuredDebtAmount(option);
                      clearErrors("unsecuredDebtAmount");
                    }}
                  >
                    {option}
                    {unsecuredDebtAmount === option && (
                      <img className="checked-icon" src={checkedIcon} alt="" />
                    )}
                  </button>
                ))}
              </div>
              {errors?.unsecuredDebtAmount && (
                <span
                  style={{
                    color: "red",
                    fontSize: "12px",
                    marginBottom: "10px",
                    display: "block",
                    textAlign: "center"
                  }}
                  className="error"
                >
                  {errors.unsecuredDebtAmount.message}
                </span>
              )}
            </div>

            <Box
              sx={{
                maxWidth: "474px",
                margin: "0 auto"
              }}
            >
              <StepBtn
                prevLink={prevLink}
                onSubmit={handleSubmit(onSubmit)}
                loading={loadingButton}
              />
            </Box>
          </form>
          <StepPreFooter />
        </div>
      </Box>
      {/* <Footer desc={false} /> */}
    </Box>
  );
};

export default UnsecuredDebtAmount;
